export default __webpack_public_path__ + "static/latest-7-f22dc1698377b654fe8f6cf07863578f.webp";